<template>
<div>
  <b-card no-body>
    <b-card-body class="px-1">
      <validation-observer ref="obs" v-slot="ObserverProps">
        <b-row>
          <b-col cols="7">
            <validation-provider name="date" rules="required">
              <b-form-datepicker v-model="match.date" locale="ja" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
            </validation-provider>
          </b-col>
          <b-col cols="5">
            <b-form>
              <b-form-select v-model="match.round" :options="roundOptions" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
            </b-form>
          </b-col>
          <b-col cols="12" v-if="readerVisibility">
            <b-row>
              <b-col cols="6" align-self="start" class="pl-0">
                <b-form-select v-model="match.readMode" :options="readModeOptions"></b-form-select>
              </b-col>
              <b-col cols="6" align-self="start" class="pr-0">
                <b-form-input v-model="match.reader" placeholder="読み/押しの人" list="utsusemiUserListReader"></b-form-input>
                <datalist id="utsusemiUserListReader">
                <option v-for="member in meibo" :key="member">{{member}}</option>
              </datalist>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" v-if="readerVisibility">
            <b-form-input v-model="match.place" placeholder="会場"></b-form-input>
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col cols="5" class="p-0">
                <b-form-select v-model="match.practiceType" placeholder="練習形式" :options="practiceTypeOptions"></b-form-select>
              </b-col>
              <b-col class="text-right p-0" align-self="end">
                <b-form-checkbox v-model="readerVisibility" class="mx-2">読みも</b-form-checkbox>
              </b-col>
              <b-col v-if="inputType == 'multi'" class="text-right p-0" align-self="end">
                <b-form-checkbox v-model="resultVisibility" class="mx-2">結果も</b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr>
        <div v-for="(item,index) in matchList" :key="index" class="my-2">
          <b-row class="text-center">
            <b-col>
              <b-form-input v-model="item.player1Name" placeholder="1人目" list="utsusemiUserList1" @update="setUid(1,item.player1Name,index)" autocomplete="off">
              </b-form-input>
              <datalist id="utsusemiUserList1">
                <option v-for="member in meibo" :key="member">{{member}}</option>
              </datalist>
              <b-row class="danRow" v-if="item.player1Kyu != '' || item.player1Dan != ''">
                <b-col class="mx-0 px-0 danCol d-flex align-items-center">
                  <div class="my-auto align-middle" style="font-size:16px;padding-left:15px">{{item.player1Kyu}}級{{item.player1Dan}}段</div>
                  <b-badge class="danBadge ml-auto" @click="$bvModal.show('editRankAndDan');setEditParams(item.player1Name)">修正</b-badge>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-form-input v-model="item.player2Name" placeholder="2人目" list="utsusemiUserList2" @update="setUid(2,item.player2Name,index)" autocomplete="off">
              </b-form-input>
              <datalist id="utsusemiUserList2">
                <option v-for="member in meibo" :key="member">{{member}}</option>
              </datalist>
              <b-row class="danRow" v-if="item.player2Kyu != '' || item.player2Dan != ''">
                <b-col class="mx-0 px-0 danCol d-flex align-items-center">
                  <div class=my-auto style="font-size:16px;padding-left:15px">{{item.player2Kyu}}級{{item.player2Dan}}段</div>
                  <b-badge class="danBadge ml-auto" @click="$bvModal.show('editRankAndDan');setEditParams(item.player2Name)">修正</b-badge>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="text-center" v-if="resultVisibility">
            <b-col>
              <b-form-select v-model="item.player1Result" :options="resultOptions" @input="setResult('player2',index)" key="input-result"></b-form-select>
            </b-col>
            <b-col>
              <validation-provider name="枚数" rules="min_value:1|max_value:48" v-slot="{ errors }">
                <b-form-input v-model="item.cardNumber" placeholder="枚数" type="number" key="input-result"></b-form-input>
                <p class="error">{{ errors[0] }}</p>
              </validation-provider>
            </b-col>
            <b-col>
              <b-form-select v-model="item.player2Result" :options="resultOptions" @input="setResult('player1',index)" key="input-result"></b-form-select>
            </b-col>
          </b-row>
          <template v-if="inputType == 'single'">
            <div style="padding-right:15px; padding-left:15px">
              <label class="mb-0">コメント</label>
              <b-form-radio-group class="my-1" v-model="commentType" :options="commentTypeOptions"></b-form-radio-group>
              <b-textarea rows="3" v-model="comment"></b-textarea>
            </div>
          </template>
          <hr v-if="resultVisibility">
          <b-row class="text-center" v-else>
          </b-row>
        </div>
        <div class="float-right">
          <b-button variant="success" class="my-2 mx-2" @click="addMatchToMatchList()" size="sm" v-if="inputType == 'multi'">行を追加</b-button>
          <b-button variant="success" class="my-2 mx-2" @click="submit()" v-b-toggle.matches :disabled="ObserverProps.invalid" size="sm">投稿</b-button>
        </div>
      </validation-observer>
    </b-card-body>
  </b-card>
  <b-modal v-bind:id="'editRankAndDan'" hide-header hide-footer modal-center>
    <b-row>
      <b-col>
        <label>{{memberEditParams.name}}さんの段と級を変更します。</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form inline>
          <b-form-select v-model="memberEditParams.rank" :options="kyuOptions"></b-form-select>
          <label for="inline-form-input-kyu">級</label>
          <b-form-select v-model="memberEditParams.dan" :options="danOptions"></b-form-select>
          <label for="inline-form-input-dan">段</label>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" class="my-2 mx-2 float-right" @click="editMeiboMember(memberEditParams);$bvModal.hide('editRankAndDan')" size="sm">変更</b-button>
      </b-col>
    </b-row>
  </b-modal>
</div>
</template>
<style>
span.description {
  display: inline-block;
}

.danRow {
  padding-top: 3px;
  height: auto;
}

.danCol {
  height: auto;
}

.danButton {
  height: 30px;
}

.danLabel {
  border: 1px solid;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 7px;
  padding-right: 7px;
}

.danBadge {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}
</style>
<script>
import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {
  ValidationProvider,
  extend
} from "vee-validate";
import {
  required,
  min_value,
  max_value,
} from "vee-validate/dist/rules";
extend('required', required);
extend('min_value', {
  ...min_value,
  message: '枚数は1以上の値を入力してください'
});
extend('max_value', {
  ...max_value,
  message: '枚数は48以下の値を入力してください'
});

export default {
  name: 'matchForm',
  props: {
    meibo:Array,
    inputType:String
  },
  data() {
    return {
      memberNameList: [],
      memberKanaList: [],
      utsusemiUserList: [],
      meiboHash: {},
      match: {
        date: dayjs(new Date()).format('YYYY-MM-DD'),
        round: 1,
        readMode:"",
        reader:"",
        place:"",
        practiceType:"uncategorized"
      },
      matchList: [],
      readModeOptions:[
        "",
        "読み",
        "ありあけ(西田)",
        "ありあけ(和家)",
        "ありあけ(吉川)",
        "ありあけ(稲葉)",
        "ありあけ(廣本)",
        "ありあけ(楠田)",
        "ありあけ(芹野)",
        "ありあけ(山下)",
        "ありあけ(五味)",
        "わすらもち"
      ],
      resultOptions: [{
          value: '',
          text: ''
        },
        {
          value: 1,
          text: '勝ち'
        },
        {
          value: 0,
          text: '負け'
        },
        {
          value: -1,
          text: '指導'
        },
      ],
      roundOptions: [{
          value: 1,
          text: '1回戦'
        },
        {
          value: 2,
          text: '2回戦'
        },
        {
          value: 3,
          text: '3回戦'
        },
        {
          value: 4,
          text: '4回戦'
        },
        {
          value: 5,
          text: '5回戦'
        },
        {
          value: 6,
          text: '6回戦'
        },
        {
          value: 7,
          text: '7回戦'
        },
        {
          value: 8,
          text: '8回戦'
        },
        {
          value: 9,
          text: '9回戦'
        },
        {
          value: 10,
          text: '10回戦'
        },
        {
          value: 11,
          text: '11回戦'
        },
      ],
      resultVisibility: true,
      readerVisibility: false,
      memberEditParams:{
        name:"",
        rank:"",
        dan:""
      },
      kyuOptions: [{
        text: "未選択",
        value: ""
      }, "A", "B", "C", "D", "E"],
      danOptions: [{
        text: "未選択",
        value: ""
      }, "10", "9", "8", "7", "6", "5", "4", "3", "2", "初", "無"],
      userName:"",
      comment: new String,
      commentType:"public",
      commentTypeOptions: [{
          value: 'public',
          text: '公開'
        },
        {
          value: 'seniorMemberOnly',
          text: '上級生のみ'
        },
        {
          value: 'private',
          text: '自分のみ',
        }
      ],
      practiceTypeOptions:[{
        value: 'uncategorized',
        text:''
      },
      {
        value:'beginner',
        text: '初心者練'
      },
      {
        value:'experienced',
        text: '経験者練'
      },
      ]
    }
  },
  components: {
    ValidationProvider,
  },
  created: function() {
    this.addMatchToMatchList();
    var _this = this;
    this.database = firebase.database();
    this.user = firebase.auth().currentUser;
    firebase.database().ref('meibo/').on("value", snapShot => {
      if (snapShot) {
        snapShot.forEach((data) => {
          let meiboMemberByYear = data.val();
          for(let member in meiboMemberByYear){
            meiboMemberByYear[member]['year'] = data.key
          }
          _this.meiboHash = Object.assign(_this.meiboHash, meiboMemberByYear)
        });
      }
    })
    firebase.database().ref('users/').on("value", snapShot => {
      if (snapShot) {
        let userList = [];
        snapShot.forEach((data) => {
          let user = data.val();
          user['uid'] = data.key;
          userList.push(user);
        });
        _this.utsusemiUserList = userList;
      }
    })
    this.database.ref('users/' + this.user.uid + '/name').once("value", snapShot => {
      if (snapShot) _this.userName = snapShot.val(); // ログインユーザー名の取得
    })

    _this.meiboHash = this.sortMeibo();
    _this.memberNameList = Object.keys(this.meiboHash)
  },
  methods: {
    submit() {
      let round = this.match.round;
      let date = this.match.date;
      let practiceType = this.match.practiceType;
      let readMode = this.match.readMode;
      let reader = this.match.reader;
      let place = this.match.place;
      let unixtime = -dayjs(this.match.date).unix();
      var recordsPostRef = firebase.database().ref('records/' + unixtime + '/' + round);
      for (let i = 0, l = this.matchList.length; i < l; i++) {
        if (this.matchList[i].player1Name == "" && this.matchList[i].player2Name == "") {
          continue;
        }
        var newPostKey = recordsPostRef.push().key;
        let obj = {};
        obj[newPostKey] = this.matchList[i];
        obj[newPostKey].date = date;
        obj[newPostKey].round = round;
        (obj[newPostKey])["key"] = newPostKey;
        obj[newPostKey].practiceType = practiceType;
        recordsPostRef.update(obj)
        let placeObj = {};
        placeObj["readMode"] = readMode;
        placeObj["reader"] = reader;
        placeObj["place"] = place;
        if(readMode != "" || reader != "" || place != ""){//読み・会場情報を投稿
        firebase.database().ref('records/' + unixtime + '/' + round+'/placeInfo').once("value", snapShot => {
          var isFoundSameReader = false;
          snapShot.forEach(function(element) {
            if(element.val().readMode==readMode&&element.val().reader==reader&&element.val().place==place) {
              isFoundSameReader = true;
            }
          })
          console.log(isFoundSameReader);
          if(isFoundSameReader == false){console.log("falseやで");
            firebase.database().ref('records/' + unixtime + '/' + round+'/placeInfo').push(placeObj);
          }
        })
        }
        //コメントの投稿
        if(this.comment != ""){
        var commentObj = {
        text: this.comment,
        unixtime: -unixtime,
        name: this.userName,
        commentType: this.commentType
        }
        // recordsにコメントを投稿し、key(id)を取得
        let commentPostRef = firebase.database().ref(`records/${unixtime}/${round}/${newPostKey}/comments`);
        let newCommentPostRef = commentPostRef.push(commentObj);
        var commentId = newCommentPostRef.key;
        }
        if (this.matchList[i].player1Uid !== '') {
          var userRecordsPostRefForPlayer1 = firebase.database().ref('userRecords/' + this.matchList[i].player1Uid + '/' + unixtime + '/' + round);
          let player1Obj = {};
          player1Obj[newPostKey] = {
            "date": date,
            "round": round,
            "opponent": this.matchList[i].player2Name,
            "opponentId": this.matchList[i].player2Uid,
            "opponentKyu": this.matchList[i].player2Kyu,
            "opponentDan": this.matchList[i].player2Dan,
            "result": this.matchList[i].player1Result,
            "key": newPostKey,
            "cardNumber": this.matchList[i].cardNumber,
          }
          if(this.comment != ""){
            player1Obj[newPostKey]["comments"]={
              [commentId]:commentObj
            }
          }
          userRecordsPostRefForPlayer1.update(player1Obj);
        }
        if (this.matchList[i].player2Uid !== '') {
          var userRecordsPostRefForPlayer2 = firebase.database().ref('userRecords/' + this.matchList[i].player2Uid + '/' + unixtime + '/' + round);
          let player2Obj = {};
          player2Obj[newPostKey] = {
            "date": date,
            "round": round,
            "opponent": this.matchList[i].player1Name,
            "opponentId": this.matchList[i].player1Uid,
            "opponentKyu": this.matchList[i].player1Kyu,
            "opponentDan": this.matchList[i].player1Dan,
            "result": this.matchList[i].player2Result,
            "key": newPostKey,
            "cardNumber": this.matchList[i].cardNumber,
          }
          if(this.comment != ""){
            player2Obj[newPostKey]["comments"]={
              [commentId]:commentObj
            }
          }
          userRecordsPostRefForPlayer2.update(player2Obj)
        }
      }
      this.matchList = [];
      this.addMatchToMatchList();
      this.match.readMode = "";
      this.match.reader = "";
      this.comment = new String;
    },
    addMatchToMatchList() {
      //対戦組合せリストに1行追加する
      const result = {
        date: dayjs(new Date()).format('YYYY-MM-DD'),
        round: "",
        player1Name: "",
        player1Uid: "",
        player1Kyu: "",
        player1Dan: "",
        player2Name: "",
        player2Uid: "",
        player2Kyu: "",
        player2Dan: "",
        player1Result: "",
        player2Result: "",
        cardNumber: "",
      }
      this.matchList.push(result);
    },
    setResult(player, index) {
      //プレイヤー1（2）の勝敗を設定したときに、プレイヤー2（1）の勝敗を設定する
      if (player == "player2") {
        if (this.matchList[index].player1Result === "" || this.matchList[index].player1Result === -1) {
          this.matchList[index].player2Result = this.matchList[index].player1Result;
        } else {
          this.matchList[index].player2Result = 1 - this.matchList[index].player1Result
        }
      } else {
        if (this.matchList[index].player2Result === "" || this.matchList[index].player2Result === -1) {
          this.matchList[index].player1Result = "" || this.matchList[index].player2Result;
        } else {
          this.matchList[index].player1Result = 1 - this.matchList[index].player2Result
        }
      }
    },
    setUid(playerSide, playerName, index) {
      //アプリ利用者の場合、Uidを設定する。段位も設定してもらう
      for (let i = 0, l = this.utsusemiUserList.length; i < l; i++) {

        if (playerName == this.utsusemiUserList[i].name) {
          if (playerSide == 1) {
            console.log(this.utsusemiUserList[i].uid)
            this.matchList[index].player1Uid = this.utsusemiUserList[i].uid;
          } else {
            this.matchList[index].player2Uid = this.utsusemiUserList[i].uid;
          }
          break;
        } else {
          if (playerSide == 1) {
            this.matchList[index].player1Uid = "";
          } else {
            this.matchList[index].player2Uid = "";
          }
        }
      }

      if (this.memberNameList.includes(playerName)) {
        console.log("あったで");
        if (playerSide == 1) {
          this.matchList[index].player1Kyu = this.meiboHash[playerName].kyu;
          this.matchList[index].player1Dan = this.meiboHash[playerName].dan;
        } else {
          this.matchList[index].player2Kyu = this.meiboHash[playerName].kyu;
          this.matchList[index].player2Dan = this.meiboHash[playerName].dan;
        }
      } else {
        if (playerSide == 1) {
          console.log("ないで");
          this.matchList[index].player1Kyu = "";
          this.matchList[index].player1Dan = "";
        } else {
          this.matchList[index].player2Kyu = "";
          this.matchList[index].player2Dan = "";
        }
      }
    },
    sortMeibo() {
      let meiboArray = new Array();
      for (let person in this.meiboHash) {
        let kana = this.meiboHash[person].kana
        let personObj = {
          "kana": kana,
          "name": person,
          "value": this.meiboHash[person]
        }
        meiboArray.push(personObj)
      }
      meiboArray.sort(function(a, b) {
        if (a.kana < b.kana) {
          return -1;
        } else {
          return 1;
        }
      });
      let meiboObj = new Object();
      for (let i in meiboArray) {
        meiboObj[meiboArray[i].name] = meiboArray[i].value
      }
      return meiboObj;
    },
    setEditParams(name){
      this.memberEditParams.name = name;
      this.memberEditParams.rank = this.meiboHash[name].kyu;
      this.memberEditParams.dan = this.meiboHash[name].dan;
      this.memberEditParams.year = this.meiboHash[name].year;
    },
    editMeiboMember(memberEditParams){
      let kyu = memberEditParams.rank
      let dan = memberEditParams.dan
      firebase.database().ref('meibo/'+memberEditParams['year']+'/'+memberEditParams['name']).update({"dan":dan})
      firebase.database().ref('meibo/'+memberEditParams['year']+'/'+memberEditParams['name']).update({"kyu":kyu})
    }
  }
}
</script>
